import React, { useEffect, useRef /*useState*/ } from "react";
import { useNavigate } from "react-router-dom";
import { getDeliveryLocations } from "../../../redux/actions/orderActions";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { isEmpty } from "lodash";

type Props = {};

const CartBottomCard = (props: Props) => {
  const { cart } = useAppSelector((state) => {
    return state.cart;
  });
   const dispatch = useAppDispatch();

  const init = useRef({ dispatch });
  const navigate = useNavigate();

  //calculate total product price
  const calculateProductTotal = (products: any) => {
    if (!products || products.length === 0) return 0;

    return products.reduce((total: any, product: any) => {
      const price = Number(product.newPrice) || Number(product.productPrice) || 0;
      const quantity = Number(product.productQty) || 0;
      return total + (price * quantity);
    }, 0);
  };
  const productTotal = calculateProductTotal(cart?.products);

  // const totalShipping =
  //   cart?.products.reduce((sum, product) => {
  //     return sum + (product.shippingCost ?? 0);
  //   }, 0) ?? 0;

  useEffect(() => {
    const { dispatch } = init.current;
    dispatch(getDeliveryLocations());
  }, []);
  //this is no longer needed based on new ui
  // const onCheckout = () => {
  //   navigate("/cart/customer");
  // };

  return (
           <div
      className="rounded-t-md flex flex-col left-0 bottom-0 inset-x-0 bg-white w-full lg:max-w-7xl lg:mx-auto font-nunito"
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex flex-col space-y-4">
        {/* reseller product cost */}
        <div className="flex justify-between items-center">
          <span className="text-body2 text-blackText">Gross</span>
          <span className="text-body1 font-semi text-blackText">
            {!isEmpty(cart) && cart.products[0]?.currency}{" "}
            {productTotal.toFixed(2)}
          </span>
        </div>

        {/* reseller profit */}
        <div className="flex justify-between items-center">
          <span className="text-body2 text-blackText">My Profit</span>
          <span className="text-body1 font-semi text-blackText">
            {!isEmpty(cart) && cart.products[0]?.currency}{" "}
            {Number(cart?.totalResellerProfit ?? 0).toFixed(2)}
          </span>
        </div>

        {/* delivery fee */}
        <div className="flex justify-between items-center">
          <span className="text-body2 text-blackText">Delivery Fee</span>
          <span className=" text-body1 font-semi text-blackText">
            {!isEmpty(cart) && cart.products[0]?.currency}{" "}
            {Number(cart?.delivery?.price ?? 0).toFixed(2)}
          </span>
        </div>
        {/* total shipping cost */}
        {/* {totalShipping && (
          <div className="flex justify-between items-center">
            <span className="text-gray-500 text-sm">Total Shipping Cost</span>
            <span className="text-sm font-bold text-gray-800">
              {!isEmpty(cart) && cart.products[0]?.currency} {totalShipping}
            </span>
          </div>
        )} */}
    </div>
    </div>
  );
};

export default CartBottomCard;
